import React from 'react';
import {fetchQuestions, fetchQuestion, fetchCurrentQuizQuestions} from 'api/question';
import {createQuiz, fetchQuiz, updateQuiz} from 'api/quiz';
import {isEmpty} from 'lodash/lang';
import InputBase from '@material-ui/core/InputBase';
import {Link, withRouter, Prompt} from 'react-router-dom';
import QuizQuestionList from './QuizQuestionList';
import QuizDetail from './QuizDetail';
import {formatErrors} from '../../actions/errors';
import {addFlashMessage} from '../../actions/flash-message';
import {connect} from 'react-redux';
import Modal from '../common/Modal';
import QuizRandomizedQuestion from './QuizRandomizedQuestion';
import {createForm} from 'rc-form';
import IconButton from '@material-ui/core/IconButton';
import {Check, Clear as ClearIcon, Close as CloseIcon} from '@material-ui/icons';
import Paper from '@material-ui/core/Paper';
import QuizToolBar from './QuizToolBar';
import RouteBlocker from '../common/RouteBlocker';
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';
import Switch from '@material-ui/core/Switch';
import {FormControlLabel} from '@material-ui/core';


class QuizCreation extends React.Component {

    constructor(props) {
        super(props);
        const {match: {params: {quizId}}} = props;
        this.quizId = quizId;
        this.state = {
            questionDataDict: {},
            questionList: null,
            quizDataDict: {},
            isQuizRandomizedQuestionModalOpen: false,
            selectedRandomizedQuestionDict: {},
            currentSelectedQuestionIndex: null,
            questionSearchTerm: '',
            pristine: true,
            advancedOptions: null,
            pushed: false,
            questionDetails: null,
            detailsModalOpen: false,
            currentQuestionBankOnly: false,
            fetchQuestionsAction: fetchQuestions,
        };
        this.searchQuestionsAction = this.searchQuestionsAction.bind(this);
        this.fetchNextQuestions = this.fetchNextQuestions.bind(this);
        this.addQuestionToQuiz = this.addQuestionToQuiz.bind(this);
        this.removeQuestionFromQuiz = this.removeQuestionFromQuiz.bind(this);
        this.saveQuiz = this.saveQuiz.bind(this);
        this.onCloseQuizRandomizedQuestionModal = this.onCloseQuizRandomizedQuestionModal.bind(this);
        this.addRandomizedQuestion = this.addRandomizedQuestion.bind(this);
        this.onSubmitRandomQuestion = this.onSubmitRandomQuestion.bind(this);
        this.editRandomizedQuizQuestion = this.editRandomizedQuizQuestion.bind(this);
        this.setDirty = this.setDirty.bind(this);
        this.setPristine = this.setPristine.bind(this);
        this.renderBreadcrumb = this.renderBreadcrumb.bind(this);
        this.getAdvancedOptions = this.getAdvancedOptions.bind(this);
        this.createOptions = this.createOptions.bind(this);
        this.showDetailsModal = this.showDetailsModal.bind(this);
        this.moveDown = this.moveDown.bind(this);
        this.moveUp = this.moveUp.bind(this);
        this.removeQuestionById = this.removeQuestionById.bind(this);
        this.toggleCurrentQuestionBank = this.toggleCurrentQuestionBank.bind(this);
    }

    setDirty(){
        this.setState({pristine: false});
    }

    setPristine(){
        this.setState({pristine: true});
    }

    getAdvancedOptions(advancedOptions) {
        this.setState({advancedOptions: advancedOptions});
    }

    createOptions(options) {

        const hasFeedback = options.feedback !== 'none';
        const includeQuestions = options.feedback === 'detailed' || options.feedback === 'full';
        const includeAnswers = options.feedback === 'full';

        return {
            showRecap: includeQuestions,
            showRecapResults: hasFeedback,
            showRecapCorrect: includeAnswers,
            alwaysShowPassfail: hasFeedback,
            topicBreakdown: hasFeedback,
            passFailThreshold: options.passingGrade,
            randomizeQuestions: options.randomizeQuestions === 'Yes',
            singleQuestionPages: options.questionsPerPage === 'One',
            webhookUrl: options.webhookUrl,
        };
    }

    editRandomizedQuizQuestion(index) {
        const {quizDataDict : {questions = []}} = this.state;
        this.setState({
            isQuizRandomizedQuestionModalOpen: true,
            currentSelectedQuestionIndex: index,
            selectedRandomizedQuestionDict: questions[index]
        });
    }

    onSubmitRandomQuestion(value) {
        const {quizDataDict, quizDataDict : {questions = []}} = this.state;
        if (this.state.currentSelectedQuestionIndex !== null) {
            questions[this.state.currentSelectedQuestionIndex] = value;
            quizDataDict.questions = questions;
            this.setState({quizDataDict: quizDataDict, isQuizRandomizedQuestionModalOpen: false});
        } else {
            quizDataDict.questions = questions.concat(value);
            this.setState({quizDataDict:  quizDataDict,
                isQuizRandomizedQuestionModalOpen: false});
        }
        this.setDirty();
    }

    addRandomizedQuestion() {
        this.setState({
            isQuizRandomizedQuestionModalOpen: true,
            currentSelectedQuestionIndex: null,
            selectedRandomizedQuestionDict: {}
        });
    }

    onCloseQuizRandomizedQuestionModal() {
        this.setState({isQuizRandomizedQuestionModalOpen: false});
    }

    fetchNextQuestions = () => {
        const {questionDataDict: {nextNum}, fetchQuestionsAction, currentQuestionBankOnly} = this.state;

        let args = {page: nextNum};

        if (currentQuestionBankOnly){
            args = {quizId: this.quizId, ...args};
        }

        fetchQuestionsAction(args).then(data => {
            this.setState({
                questionDataDict: data,
                questionList: this.state.questionList.concat(data.items)
            });
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {pristine = true, pushed = false, currentQuestionBankOnly} = this.state;
        const {router} = this.context;
        if (!pristine) {
            if (!pushed) {
                history.pushState(null, null, location.href);
                this.setState({pushed: true});
            }
            window.onpopstate = function () {
                router.history.push('/quizzes');
            };
        }
        else {
            window.onpopstate = function () {
                history.go(0);
            };
        }
        if (currentQuestionBankOnly !== prevState.currentQuestionBankOnly) {
            this.setState({fetchQuestionsAction: currentQuestionBankOnly ? fetchCurrentQuizQuestions : fetchQuestions});
            if (currentQuestionBankOnly) {
                fetchCurrentQuizQuestions({quizId: this.quizId}).then(data =>
                    this.setState({
                        questionDataDict: data,
                        questionList: data.items
                    })
                );
            }
            else {
                fetchQuestions({}).then(data =>
                    this.setState({
                        questionDataDict: data,
                        questionList: data.items
                    }));
            }
        }
    }

    componentDidMount() {
        this.setState({pushed: false});
        const {fetchQuestionsAction, currentQuestionBankOnly} = this.state;
        if (this.quizId) {
            let args = {};
            if (currentQuestionBankOnly) {
                args = {quizId: this.quizId};
            }
            fetchQuestionsAction(args).then(data => {
                this.setState({
                    questionDataDict: data,
                    questionList: data.items
                });
            });
        }
        if (this.quizId) {
            const {addFlashMessage, match: {params: {quizId}}} = this.props;
            const {router} = this.context;
            fetchQuiz(quizId)
                .then(quizDataDict => {
                    this.setState({quizDataDict});
                }).catch(() => {
                    addFlashMessage('Failed finding the quiz!', 'error');
                    router.history.push('/quizzes');
                });
        }
    }

    removeQuestionFromQuiz(e, index) {
        e.stopPropagation();
        const {quizDataDict, quizDataDict : {questions = []}} = this.state;
        let quizQuestionsList = [...questions];
        quizQuestionsList.splice(index, 1);
        quizDataDict.questions = quizQuestionsList;
        this.setState({quizDataDict});
        this.setDirty();
    }

    removeQuestionById(id){
        const {quizDataDict, quizDataDict : {questions = []}} = this.state;
        let quizQuestionsList = [...questions];
        quizQuestionsList = quizQuestionsList.filter(
            q => q._cls !== 'Question' || q._id.$oid !== id
        );
        quizDataDict.questions = quizQuestionsList;
        this.setState({quizDataDict});
        this.setDirty();
    }

    addQuestionToQuiz(questionId) {
        const {quizDataDict, quizDataDict : {questions = []}} = this.state;
        fetchQuestion(questionId).then(data => {
            quizDataDict.questions = questions.concat(data);
            this.setState({quizDataDict});
            this.setDirty();
        });
    }

    toggleCurrentQuestionBank(e){
        this.setState({currentQuestionBankOnly: e.target.checked});
    }

    questionSearchBox() {
        const {questionDataDict} = this.state;

        return (
            <>
                <Paper className="quiz-search-root">
                    <InputBase
                        placeholder="Search"
                        inputProps={{'aria-label': 'Search'}}
                        onChange={this.searchQuestionsAction}
                    />
                    <IconButton aria-label="Search">
                        <ClearIcon/>
                    </IconButton>
                </Paper>
                <FormControlLabel
                    control={
                        <Switch
                            color={'secondary'}
                            onChange={this.toggleCurrentQuestionBank}
                        />
                    }
                    label={'Only current question bank'}
                    labelPlacement={'start'}
                />
                <p>{questionDataDict.totalCount} question{questionDataDict.totalCount>1 ? 's' : ''} total</p>
            </>
        );
    }

    searchQuestionsAction(e) {
        const {fetchQuestionsAction, currentQuestionBankOnly} = this.state;
        const searchTerm = e.target.value.trim();
        let searchQuery = {page: 1};
        if (!isEmpty(searchTerm)) {
            searchQuery['q'] = searchTerm;
        }
        let args = searchQuery;
        if (currentQuestionBankOnly) {
            args = {quizId: this.quizId, ...args};
        }
        fetchQuestionsAction(args).then(data => {
            this.setState({
                questionDataDict: data,
                questionList: data.items,
                questionSearchTerm: searchTerm
            });
        });
    }

    saveQuiz(e) {
        e.preventDefault();
        const {form: {validateFields}} = this.props;
        const {quizDataDict: {questions = []}, advancedOptions} = this.state;
        const {addFlashMessage, formatErrors} = this.props;

        validateFields((error, value) => {
            if (!isEmpty(error)) {
                return;
            }

            const questionsList = questions.map(item => item).reduce(
                (accumulator, currentValue) => {
                    if (currentValue._cls === 'Question') {
                        accumulator.push(currentValue._id.$oid);
                    } else {
                        // Randomized Question.
                        accumulator.push({
                            number_of_questions: parseInt(currentValue.numberOfQuestions),
                            topic: currentValue.topic,
                            subtopic: currentValue.subtopic
                        });
                    }
                    return accumulator;
                }, []);

            if (this.quizId) {
                updateQuiz(this.quizId,{
                    name: value.name,
                    start_message: value.start_message,
                    end_message: value.end_message,
                    questions: questionsList,
                    options:this.createOptions(advancedOptions),
                }).then(() => {
                    addFlashMessage('Quiz successfully updated', 'success');
                    this.setPristine();
                }).catch(err =>
                    formatErrors(err
                    ).then(error => {
                        this.setState({
                            error
                        });
                    })
                );
            } else {
                createQuiz({
                    name: value.name,
                    start_message: value.start_message,
                    end_message: value.end_message,
                    questions: questionsList,
                    options:this.createOptions(advancedOptions),
                }).then((quizDataDict) => {
                    this.setState({pristine: true}, () => {
                        this.props.history.push(`/quizzes/${quizDataDict._id.$oid}/edit`);
                        addFlashMessage('Quiz successfully saved', 'success');
                    });
                }).catch(err =>
                    formatErrors(err
                    ).then(error => {
                        this.setState({
                            error
                        });
                    })
                );
            }
        });
    }

    renderBreadcrumb(quizId){
        if (quizId){
            if (this.state.quizDataDict) {
                return this.state.quizDataDict.name;
            }
            else {
                return 'Update Quiz';
            }
        }
        return 'Create New Quiz';
    }

    showDetailsModal(question){
        this.setState({
            questionDetails: question,
            detailsModalOpen: true
        });
    }

    moveUp(questionIndex){
        const {quizDataDict, advancedOptions} = this.state;
        let questions = quizDataDict.questions;
        if (questionIndex > 0) {
            [questions[questionIndex-1], questions[questionIndex]] = [questions[questionIndex], questions[questionIndex-1]];
        }
        if (advancedOptions.randomizeQuestions && advancedOptions.randomizeQuestions !== 'No'){
            this.props.addFlashMessage('Questions will no longer be randomized', 'warning');
        }
        let options = {...advancedOptions, randomizeQuestions:false};
        this.setState({quizDataDict : {...quizDataDict, questions, options: this.createOptions(options)}});
        this.setDirty();
    }

    moveDown(questionIndex){
        const {quizDataDict, advancedOptions} = this.state;
        let questions = quizDataDict.questions;
        if (questionIndex < questions.length-1) {
            [questions[questionIndex], questions[questionIndex+1]] = [questions[questionIndex+1], questions[questionIndex]];
        }
        if (advancedOptions.randomizeQuestions && advancedOptions.randomizeQuestions !== 'No'){
            this.props.addFlashMessage('Questions will no longer be randomized', 'warning');
        }
        let options = {...advancedOptions, randomizeQuestions:false};
        this.setState({quizDataDict : {...quizDataDict, questions, options: this.createOptions(options)}});
        this.setDirty();
    }

    render() {
        const {questionDataDict: {page, hasNext}, questionList = [],
            isQuizRandomizedQuestionModalOpen, selectedRandomizedQuestionDict, quizDataDict, pristine,
            detailsModalOpen, questionDetails} = this.state;
        const {form} = this.props;

        return (
            <>
                <RouteBlocker
                    when={!pristine}
                    shouldBlockNavigation={
                        (location) =>
                        {
                            return !pristine;
                        }
                    }
                    messageHeading="You are about to exit the quiz without saving"
                    navigate={(path) => this.context.router.history.push(path)}
                    confirmButtonText="Continue without saving"
                    cancelButtonText="Go back"
                    swapConfirmClose={true}
                    iconComponent={QuizExitIcon}
                />
                <Modal
                    title=""
                    onClose={() => this.setState({detailsModalOpen: false, questionDetails: null })}
                    open={detailsModalOpen}
                    fullWidth={true}
                    maxWidth="lg"
                >
                    {!isEmpty(questionDetails) && <>
                        <h3 color="primary"> Question Name: {questionDetails.name} </h3>
                        <div className="content-box width-100">
                            <div key={`question-panel-for-question-${questionDetails.id}`}>
                                <div >
                                    <div className={'quiz-question-content question-container'}
                                        dangerouslySetInnerHTML={{__html: questionDetails.content}}/>
                                    <ul className="ul-take-quiz">
                                        { questionDetails.answers.map((answer, questionAnswerIndex) => (
                                            <li key={`quiz-question-${questionAnswerIndex}`}>
                                                <div className="quiz-question-list-item-container">
                                                    {answer.correct ? <Check className="quiz-check-green"/> :
                                                        <CloseIcon className="quiz-incorrect-label"/>}
                                                    <div className={'quiz-question-content'}
                                                        dangerouslySetInnerHTML={{__html: answer.content}}/>
                                                </div>
                                            </li>
                                        ))
                                        }
                                    </ul>
                                    <hr/>
                                </div>
                            </div>
                        </div>
                    </>}
                </Modal>
                <div className="quiz-list-container">
                    <div>
                        <Modal
                            title="Add Randomized Questions"
                            onClose={this.onCloseQuizRandomizedQuestionModal}
                            open={isQuizRandomizedQuestionModalOpen}
                            maxWidth="xs"
                        >
                            <QuizRandomizedQuestion
                                onSubmit={(e, index) => this.onSubmitRandomQuestion(e, index)}
                                initialValues={selectedRandomizedQuestionDict}
                            />
                        </Modal>
                        <div id="quiz-list-scrollable-container">
                            {this.questionSearchBox()}
                            {!isEmpty(questionList) && <QuizQuestionList
                                fetchData={(args) => this.fetchNextQuestions({...args,})}
                                hasNext={hasNext}
                                page={page}
                                questionList={questionList}
                                addQuestionToQuiz={(questionId) => this.addQuestionToQuiz(questionId)}
                                showDetailsModal={(question) => this.showDetailsModal(question)}
                                currentQuestionIds={quizDataDict ? quizDataDict.questions ?
                                    quizDataDict.questions.reduce(
                                        (accum, ele) => ele._cls === 'Question' ? accum.concat(ele._id.$oid) : accum, [])
                                    : [] : []}
                                removeQuestionFromQuiz={this.removeQuestionById}
                            />}
                        </div>
                    </div>
                    <div className="quiz-details-container">
                        <div className="navigation-history-container">
                            {/*<Button size="small" color="primary" onClick={() => history.back()}>*/}
                            {/*    <ChevronLeftIcon/> Back*/}
                            {/*</Button>*/}
                            <Link to="/quizzes">My Quizzes</Link> > {this.renderBreadcrumb(this.quizId)}
                        </div>
                        <QuizToolBar quizId={this.quizId} saveQuiz={this.saveQuiz} preview={pristine}
                            previewQuiz={() => this.props.history.push(`/quizzes/${quizDataDict._id.$oid}/preview`)}/>
                        <QuizDetail
                            getAdvancedOptions={this.getAdvancedOptions}
                            quizDataDict={quizDataDict}
                            addRandomizedQuestion={this.addRandomizedQuestion}
                            removeQuestionFromQuizAction={(e, index) => this.removeQuestionFromQuiz(e, index)}
                            editRandomizedQuizQuestionAction={(e, index) => this.editRandomizedQuizQuestion(e, index)}
                            form={form}
                            onChange={this.setDirty}
                            moveUp={this.moveUp} moveDown={this.moveDown}
                        />
                    </div>
                </div>
            </>
        );
    }
}

const QuizExitIcon = (props) => (
    <Icon {...props}>
        <img src="/images/quiz_exit.svg" style={{width: 'inherit'}}/>
    </Icon>
);

const mapDispatchToProps = (dispatch) => ({
    formatErrors: (...args) => dispatch(formatErrors(...args)),
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuizCreation.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    mapDispatchToProps
)(createForm()(QuizCreation)));
